import { find, map, get, compact } from 'lodash';
import empty from './dashboards/empty';
import overview from './dashboards/overview';
import reports from 'lib/report-library';

class DashboardLibrary {
	constructor() {
		this.dashboards = [];
	}

	addDashboard(dashboard) {
		this.dashboards.push(dashboard);
	}

	all() {
		return [...this.dashboards];
	}
	
	// find and normalize the dashboard config
	//
	find(id) {
		let dashboard = find(this.dashboards, { id });
		if (dashboard) {
			return {
				...dashboard,
				items: compact(
					map(dashboard.items, ({ widget, position }) => {
						let report = get(find(reports, { id: widget }), 'report');
						if (report) {
							return {
								widget: report,
								position,
							};
						}
						return false;
					}),
				),
			};
		}
		return null;
	}
}

let dashboardLibrary;

if (!dashboardLibrary) {
	dashboardLibrary = new DashboardLibrary();
}

dashboardLibrary.addDashboard(empty);
dashboardLibrary.addDashboard(overview);

export default dashboardLibrary;
